import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TeacherLogin(){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    // static credentials
    if (email === 'hapanisameer@gmail.com' && password === 'Abc@1234'){
      navigate('/home');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden md:block md:w-7/12 bg-cover bg-right" style={{ backgroundImage: `url('/school-mis.png')`, backgroundPosition: 'right' }} />
      <div className="w-full md:w-5/12 flex items-center justify-center p-8">
        <div className="max-w-md w-full space-y-6">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo-sedim.jpg" alt="logo" className="h-12 w-12 rounded-md object-cover" />
            <div className="leading-tight">
              <div className="text-xl font-semibold text-gray-800">School Management System</div>
              <div className="text-s text-gray-500"></div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow p-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Teacher Login</h2>
            <form onSubmit={onSubmit}>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input value={email} onChange={e => setEmail(e.target.value)} className="w-full border px-3 py-2 rounded mb-4" />
              <label className="block text-sm font-medium text-gray-700">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full border px-3 py-2 rounded mb-4" />
              {error && <div className="text-red-600 mb-3">{error}</div>}
              <div className="flex justify-end">
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">Login</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
